import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import { Col, Row, Container } from "react-bootstrap";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { videoPath } from "../helper";
import GallerySection from "../components/GallerySection";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import SunWestLogo from "../images/SunWest-Logo.png";
import PhoneIcon from "../images/phone_icon.svg";
import VideoBtn from "../images/VideoButton.svg";
import ApprovalCondi from "../images/8am approval and 2 hour logo.png";
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu/index"
import "../css/Header.css";

export default function Header({ wholesaleurlData }) {
  const [isOpen, setOpen] = useState(false);

  const [navbar, setNavbar] = useState(false);

  const changebackground = () => {
    if (window.scrollY >= 9) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changebackground);

  return (
    <>
      <Navbar
        collapseOnSelect
        className="px-2 px-md-3 px-lg-5 {navbar ? 'navbar active' : 'navbar' }"
        bg="light"
        expand="lg"
        fixed="top"
      >
        <Navbar.Brand xl={4} lg={12} className="">
          <a
            href="https://www.swmc.com"
            target="_blank"
            rel="noreferrer noopener"
            className="a-link"
          >
            <img
              src={SunWestLogo}
              alt="Sun West logo"
              className="App-logo ml-0"
              width="300px"
              height="65px"
            />
          </a>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse className="justify-content-end" id="basic-navbar-nav">
          <Nav>
            <Container xl={10} lg={12} className="header-buttons-col"

            >
               <div className="mobile-AccessibilityMenu-show">
        <UserWayAccessibilityMenu color="black" width={40} height={40} />
      </div>
              <Row className="header-button-row">
                <Col className="nav-item" md={3} sm={6} xs={12}>
                  <a
                    href="tel:+19514944090"
                    className="nav-bar-a"
                    style={{ color: "white" }}
                  >
                    <div className="button-div-new">
                      <span>
                        <img
                          className="phoneIcon"
                          src={PhoneIcon}
                          alt="Phone icon"
                          width="12px"
                          height="15px"
                        />{" "}
                        (951) 494-4090
                      </span>
                    </div>
                  </a>
                </Col>
                {/* <Col className="nav-item" md={3} sm={6} xs={12}>
              <div
                onClick={() => {
                  let scrollToTable = document.getElementById("rateTable");
                  scrollToTable.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }}
                className="button-div-new"
              >
                See Our Rates
              </div>
            </Col> */}
                <Col className="nav-item" md={3} sm={6} xs={12}>
                  <AnchorLink
                    href="#applyNowForm"
                    className="nav-bar-a"
                    style={{ color: "white" }}
                  >
                    <div className="button-div-new">Connect With Us</div>
                  </AnchorLink>
                </Col>
                <Col className="nav-item" md={3} sm={6} xs={12}>
                  <a
                    href={wholesaleurlData}
                    className="nav-bar-a"
                    target="_blank"
                    style={{ color: "white" }}
                    rel="noreferrer"
                  >
                    <div className="button-div-new">View Product Guidelines</div>
                  </a>
                </Col>
              </Row>
            </Container>
          </Nav>
        </Navbar.Collapse>
        <div className="desktop-AccessibilityMenu-show">
          <UserWayAccessibilityMenu color="black" width={40} height={40} />
        </div>
       
      </Navbar>
     
      <Container fluid>
        <Row
          style={{
            margin: "0",
            padding: "0",
          }}
        >
        </Row>

        <Row className="banner-top align-items-center header-d" onClick={() => setOpen(true)}>
          <Col lg={6} md={7} sm={12} className="mb-4">
            <p>
              <div className="video-heading-line">Preferred Originator Partner</div>
              <div className="video-heading-line2 mt-3 mb-4">
                {" "}
                <span>Stop losing your loans to online retailers, <br />join our amazing organization now.
                </span>
                {" "}
              </div>
            </p>
            <img
              className="side-image img-fluid"
              src={ApprovalCondi}
              alt="12 Hour and 2 Hour"
            />
          </Col>
          <Col lg={6} md={5} sm={12} className="text-center">
            <GallerySection />
          </Col>

        </Row>
      </Container>
    </>
  );
}
